import {
    createSelector,
} from 'reselect';

import SLICE_NAMESPACE from '../../types';
import NAMESPACE from './types';

function _getPriceData(appState) {
    return appState[SLICE_NAMESPACE][NAMESPACE];
}

const selectMinimumDailyPrices = createSelector(
    _getPriceData,
    (priceData) => priceData
        ? priceData.minimumDailyPrices
        : undefined,
);

const selectMinimumDailyPricesFromPlace = createSelector(
    (appState, placeId) => placeId,
    selectMinimumDailyPrices,
    (placeId, priceData) => (priceData && placeId)
        ? priceData[placeId]
        : undefined,
);

const selectMinimumDailyPricesFromPlaceToPlace = createSelector(
    (appState, fromPlace, toPlace) => toPlace,
    selectMinimumDailyPricesFromPlace,
    (placeId, priceData) => (priceData && placeId)
        ? priceData[placeId]
        : undefined,
);

const _mapDailyMinimumPrice = (direction) => (data) => data
    ? data[direction === 'return'
        ? 'returnMinPricing'
        : 'departMinPricing'].price
    : undefined;

const selectDailyDepartMinimumPricing = createSelector(
    selectMinimumDailyPricesFromPlaceToPlace,
    _mapDailyMinimumPrice('depart'),
);

const selectDailyReturnMinimumPricing = createSelector(
    selectMinimumDailyPricesFromPlaceToPlace,
    _mapDailyMinimumPrice('return'),
);

export {
    selectDailyDepartMinimumPricing,
    selectDailyReturnMinimumPricing,
    selectMinimumDailyPrices,
    selectMinimumDailyPricesFromPlace,
    selectMinimumDailyPricesFromPlaceToPlace,
};
